// extracted by mini-css-extract-plugin
module.exports = {"imageBox":"UseCaseHero-module--imageBox--qJhZC","bgBlock":"UseCaseHero-module--bgBlock--1uGZF","content":"UseCaseHero-module--content--1hAod"};